import { InputAdornment } from '@mui/material';
import { styled } from '@mui/material/styles';
import { TextField as TextFieldComponent, Typography } from '@raisin/components-lib';

export const TextField = styled(TextFieldComponent)(({ theme, $noPadding }) => ({
  gap: 0,

  ...($noPadding && {
    '.MuiInputBase-input': {
      paddingLeft: '0 !important',
    },
  }),

  '.MuiInputLabel-root': {
    position: 'absolute',
  },

  '.MuiFormHelperText-root': {
    marginTop: theme.spacing(1),
  },
}));

export const Title = styled(Typography)(({ theme }) => ({
  fontWeight: theme.typography.body1.fontWeight,

  [theme.breakpoints.down('lg')]: {
    fontWeight: theme.typography.subtitle1.fontWeight,
  },
}));

export const SubTitle = styled(Typography)(({ theme }) => ({
  [theme.breakpoints.down('lg')]: {
    fontWeight: theme.typography.subtitle1.fontWeight,
  },
}));

export const Description = styled(Typography)(({ theme }) => ({
  [theme.breakpoints.down('lg')]: {
    fontSize: theme.typography.subtitle1.fontSize,
  },
}));

export const Label = styled(Typography)(({ theme, $hasError }) => ({
  color: $hasError ? theme.palette.error.main : theme.palette.black80.main,
}));

export const Adornment = styled(InputAdornment)(({ theme }) => ({
  marginLeft: theme.spacing(3),
  marginRight: '0 !important',
}));
